import { useMemo } from 'react';
import { ChatMessageBubble, ExpandableText, ToolCallCard } from '@spark';
import { groupTrajectory, trajectoryMessages } from '@/features/datasets';

/** Line clamp before Spark `ExpandableText` offers "Show more", as in the Data Editor. */
const BUBBLE_MAX_LINES = 4;

/**
 * The conversation an agentic run produced, rendered in a Playground output
 * cell: user bubbles left, assistant bubbles right, and a `ToolCallCard` for
 * each assistant tool call paired with its tool response.
 *
 * Same grouping the Data Editor uses for a stored trajectory, so a previewed
 * run and the benchmark row it will become read identically.
 */
export const PlaygroundTrajectory = ({ trajectory }) => {
    const items = useMemo(
        () => groupTrajectory(trajectoryMessages({ trajectory })),
        [trajectory],
    );
    if (items.length === 0) return null;

    return (
        <div className="pg-trajectory" data-testid="pg-trajectory">
            {items.map((item) =>
                item.kind === 'tool_call' ? (
                    <ToolCallCard
                        key={item.key}
                        name={item.name}
                        summary={item.summary}
                        argumentsText={item.arguments}
                        responseText={item.response}
                    />
                ) : (
                    <ChatMessageBubble key={item.key} role={item.role}>
                        <ExpandableText text={item.content} maxLines={BUBBLE_MAX_LINES} color="primary" />
                    </ChatMessageBubble>
                ),
            )}
        </div>
    );
};

export default PlaygroundTrajectory;
